/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { ref, onMounted, createApp, nextTick, watch } from "vue";
import Tabs from "@/class/Tabs";
import { internalSelectionDark } from "naive-ui";

export function useContent(id: string, pID: string) {
  let content = ref("");
  let articleID = ref("");
  let parentID = ref("");

  setArticleID(id);
  setparentID(pID);

  onMounted(() => {
    fetchContent();
  });

  function setArticleID(id: string) {
    articleID.value = id;
  }
  function setparentID(pID: string) {
    parentID.value = pID;
  }

  function fetchContent() {
    jsonp("https://news-my.web.sdo.com/UniInterface/news/newscontent.asp", {
      Article: articleID.value, ApplicationCode: "20",
      Type: "json",
    }).then((res: any) => {
      if (res.ApplicationCode != 20) {
        return false;
      }

      content.value = res.Content;

      nextTick(() => {
        let tabDom = document.querySelectorAll("tab");

        if (!parentID.value) {
          tabDom.forEach((dom) => {
            let content = dom.innerHTML;

            new Tabs(dom, content!, articleID.value);
          });

          if (res.Title) {
            document.title = res.Title + " - 冒险岛次元站";
          } else {
            document.title = "冒险岛次元站";
          }
        }
      });
    });
  }

  return { content, fetchContent, setArticleID, setparentID };
}
